import React, { useState, useEffect, useRef, Fragment } from "react";
import { GroundControlPanelWrapper } from "./";

// components
import { ModuleInputs, RackingInputs, PerformanceInputs, LayoutInputs, SimpleInputs, TopographyInputs, InputHeader } from "./";
import { ProjectManager } from "../ProjectManager";

// assets
import { performance, mountains, product, racking_icon } from "../../assets";

// antd
import { Button, Menu, Dropdown, Collapse, Empty, Typography, message, Select, Input } from "antd";
import { DownOutlined } from "@ant-design/icons";

// Redux
import { useSelector, useDispatch } from "react-redux";
import { portalActions, getGroundMountInputs, inputsActions, run_job, execute_job } from "../Redux";

const GroundMountControlPanel = () => {
  const portal = useSelector((state) => state.portal);
  const inputs = useSelector((state) => state.inputs);
  const dispatch = useDispatch();
  const toolPanelInput = useRef(null);

  const [panelScrollPosition, setPanelScrollPosition] = useState(0);
  const [panelOffsetTop, setpanelOffsetTop] = useState(0);
  const [topo_action, setTopoAction] = useState("nothing");
  const [visDiv, setVisDiv] = useState(true);

  const getScrollPosition = () => {
    setpanelOffsetTop(toolPanelInput.current.offsetTop);
    setPanelScrollPosition(toolPanelInput.current.scrollTop);
  };

  const submissionValidate = () => {
    // Do some validations before running
    if (portal.inputs.doOverrideDims) {
      for (var p in portal.inputs.current_product.filter((product) => product.active)) {
        for (var i in portal.inputs.current_product[p]) {
          if (i != "active" && i != "continous") {
            // light weight force value to be float
            var val = parseFloat(portal.inputs.current_product[p][i]);
            if (isNaN(val) && i != "key") {
              message.error("Non-Number value detected in one of the override dimensions", 3);
              return false;
            }
            portal.inputs.current_product[p][i] = val;
          }
        }
      }
    }
    if (portal.inputs.doOverrideGCR) {
      if (portal.inputs.OverrideGCR[0] > portal.inputs.OverrideGCR[1]) {
        message.error("Minimum GCR must be lower or equal to Maximum GCR", 3);
        return false;
      }
      if (portal.inputs.OverrideGCR[0] < 0.2 || portal.inputs.OverrideGCR[0] > 0.95) {
        message.error("Minimum GCR is not valid. Keep it between 0.2-0.9", 3);
        return false;
      }
      if (portal.inputs.OverrideGCR[1] < 0.2 || portal.inputs.OverrideGCR[1] > 0.95) {
        message.error("Maximum GCR is not valid. Keep it between 0.2-0.9", 3);
        return false;
      }
    }
    if (portal.inputs.selectedProductIndex < 0) {
      message.error("Please select a Product to analyze", 3);
      return false;
    }
    if (portal.inputs.selectedModuleIndex < 0) {
      message.error("Please select a Module", 3);
      return false;
    }
    if (!portal.inputs.features || Object.values(portal.inputs.features).length == 0) {
      message.error("No Boundary!", 3);
      return false;
    }
    if (portal.uiControls.isDrawing) {
      message.error("Finish drawing polygon before running.", 3);
      return false;
    }
    if (portal.inputs.doOverrideTilt) {
      if (isNaN(portal.inputs.OverrideTilt[0]) || typeof portal.inputs.OverrideTilt[0] == "undefined") {
        message.error("Min tilt is Not-A-Number", 3);
        return false;
      }
      if (isNaN(portal.inputs.OverrideTilt[1]) || portal.inputs.OverrideTilt[1] == "undefined") {
        message.error("Max tilt is Not-A-Number", 3);
        return false;
      }
      if (portal.inputs.OverrideTilt[0] > portal.inputs.OverrideTilt[1]) {
        message.error("Min tilt greater than Max tilt", 3);
        return false;
      }
      if (portal.inputs.OverrideTilt[0] == 0 && portal.inputs.OverrideTilt[1] == 0) {
        message.error("Please enter a min/max for Tilt", 3);
        return false;
      }
    }
    if (isNaN(portal.inputs.performance.dc_degrade)) {
      message.error("Non-Number value detected in DC Degradation", 3);
      return false;
    }		
    if (isNaN(portal.inputs.performance.dc_thermal_Uc)) {
      message.error("Non-Number value detected in Thermal Constant Loss", 3);
      return false;
    }		
    if (isNaN(portal.inputs.performance.dc_thermal_Uv)) {
      message.error("Non-Number value detected in Thermal Wind Loss", 3);
      return false;
    }		
    if (isNaN(portal.inputs.performance.dc_module_quality_loss)) {
      message.error("Non-Number value detected in Mod Quality Loss", 3);
      return false;
    }		
    if (isNaN(portal.inputs.performance.dc_module_lid_loss)) {
      message.error("Non-Number value detected in Mod LID Loss", 3);
      return false;
    }		
    if (isNaN(portal.inputs.performance.dc_module_mismatch)) {
      message.error("Non-Number value detected in DC Module Mismatch", 3);
      return false;
    }		
    if (isNaN(portal.inputs.performance.dc_strings_mismatch)) {
      message.error("Non-Number value detected in DC Strings Mismatch", 3);
      return false;
    }		
    if (isNaN(portal.inputs.performance.dc_wiring_loss_at_stc)) {
      message.error("Non-Number value detected in DC Wiring Loss @ STC", 3);
      return false;
    }		
    if (isNaN(portal.inputs.performance.bi_back_mismatch)) {
      message.error("Non-Number value detected in Bifacial Back Mismatch", 3);
      return false;
    }		
    if (isNaN(portal.inputs.performance.ac_aux_kw)) {
      message.error("Non-Number value detected in Auxiliaries", 3);
      return false;
    }		
    if (isNaN(portal.inputs.performance.ac_wiring_loss_at_stc)) {
      message.error("Non-Number value detected in AC Wiring Loss @ STC", 3);
      return false;
    }		
    if (isNaN(portal.inputs.performance.ac_transformer_loss_constant)) {
      message.error("Non-Number value detected in Transformer Constant Loss", 3);
      return false;
    }		
    if (isNaN(portal.inputs.performance.ac_transformer_loss_at_stc)) {
      message.error("Non-Number value detected in Transformer Loss @ STC", 3);
      return false;
    }		
    if (isNaN(portal.inputs.performance.ac_MV_line_loss_stc)) {
      message.error("Non-Number value detected in MV Line Loss @ STC", 3);
      return false;
    }		
    if (isNaN(portal.inputs.performance.ac_transmission_loss)) {
      message.error("Non-Number value detected in Transmission Loss", 3);
      return false;
    }		
    if (isNaN(portal.inputs.performance.ac_other_loss)) {
      message.error("Non-Number value detected in Other AC Losses", 3);
      return false;
    }		
    if (isNaN(portal.inputs.performance.simple_inverter_dcac)) {
      message.error("Non-Number value detected in DC:AC", 3);
      return false;
    }		
    if (isNaN(portal.inputs.performance.soiling_single)) {
      message.error("Non-Number value detected in Soiling loss", 3);
      return false;
    }		
    if (isNaN(portal.inputs.performance.albedo_single)) {
      message.error("Non-Number value detected in Albedo", 3);
      return false;
    }				

    // if (isNaN(portal.inputs.losses.soiling_loss)) {
    //   message.error("Non-Number value detected in soiling loss", 3);
    //   return false;
    // }
    // if (isNaN(portal.inputs.losses.mismatch_loss)) {
    //   message.error("Non-Number value detected in DC Mismatch loss", 3);
    //   return false;
    // }
    // if (isNaN(portal.inputs.losses.wiring_loss)) {
    //   message.error("Non-Number value detected in DC Wiring loss", 3);
    //   return false;
    // }
    // if (isNaN(portal.inputs.losses.module_lid_loss)) {
    //   message.error("Non-Number value detected in Module LID loss", 3);
    //   return false;
    // }
    // if (isNaN(portal.inputs.losses.module_quality_loss)) {
    //   message.error("Non-Number value detected in Module Quality loss", 3);
    //   return false;
    // }
    // if (isNaN(portal.inputs.losses.inverter_eff)) {
    //   message.error("Non-Number value detected in Inverter Efficiency loss", 3);
    //   return false;
    // }
    // if (isNaN(portal.inputs.losses.combined_ac_loss)) {
    //   message.error("Non-Number value detected in Combined AC loss", 3);
    //   return false;
    // }
    // if (isNaN(portal.inputs.bifaciality)) {
    //   message.error("Non-Number value detected in Bifaciality", 3);
    //   return false;
    // }
    // if (isNaN(portal.inputs.bifacial_ground_clearance_height)) {
    //   message.error("Non-Number value detected in Clearance Height", 3);
    //   return false;
    // }
    // if (isNaN(portal.inputs.bifacial_transmission_factor)) {
    //   message.error("Non-Number value detected in Transmission Percent", 3);
    //   return false;
    // }
    // if (isNaN(portal.inputs.bifacial_structure_shade_factor)) {
    //   message.error("Non-Number value detected in Structural Shade", 3);
    //   return false;
    // }
    if (isNaN(portal.inputs.ns_grade_limit)) {
      message.error("Non-Number value detected in NS Grade Limit", 3);
      return false;
    }
    if (isNaN(portal.inputs.ew_grade_limit)) {
      message.error("Non-Number value detected in EW Grade Limit", 3);
      return false;
    }
    if (isNaN(portal.inputs.u_grade_limit)) {
      message.error("Non-Number value detected in Universal Grade Limit", 3);
      return false;
    }

    return true;
  };

	function isNumber(value) {
		return typeof value === "number" && !isNaN(value);
	}
	function getGCRs(min, max, inc) {
		if (!isNumber(min) || !isNumber(max) || !isNumber(inc)) {
			return [0.5];
		}
		let gcrs = [];
		for (let gcr = min; gcr < max; gcr += inc) {
			gcrs.push(gcr);
			if (gcrs.length >= 51) break;
		}
		gcrs.push(parseFloat(max));
		return gcrs;
	}
	function getTilts(min, max, inc) {
		if (!isNumber(min) || !isNumber(max) || !isNumber(inc)) {
			return [25];
		}
		let tilts = [];
		for (let tilt = min; tilt < max; tilt += inc) {
			tilts.push(tilt);
			if (tilts.length >= 20) break;
		}
		tilts.push(parseFloat(max));
		return tilts;
	}
  const collectInputs = (inc_features = true) => {
    return {
      features: inc_features ? Object.values(portal.inputs.features) : undefined,

			tab: portal.uiControls.tab,
			
      center: portal.inputs._map_center,
      // azimuth: portal.inputs.azimuth,
      // doRoads: portal.inputs.doRoads,
      // doAlign: portal.inputs.doAlign,

      selectedProductIndex: portal.inputs.selectedProductIndex,
      // selectedModuleIndex: portal.inputs.selectedModuleIndex,
      selectedModuleIndex: undefined,
      module: portal.inputs.selectedModule,

      doOverrideTilt: portal.inputs.doOverrideTilt,
      OverrideTilt: [portal.inputs.OverrideTilt[0], portal.inputs.OverrideTilt[1]],
      doOverrideGCR: portal.inputs.doOverrideGCR,
      OverrideGCR: [portal.inputs.OverrideGCR[0], portal.inputs.OverrideGCR[1]],
      doEWShifting: true,
      doOverrideDims: portal.inputs.doOverrideDims,
      // overrideDims: [portal.inputs.current_product.filter(product => product.active)],
      product: portal.inputs.current_product,
      do_continuous: portal.inputs.do_continuous,

      do_dc_lock: portal.inputs.do_dc_lock,
      dc_lock_value: isNaN(portal.inputs.dc_lock_value) == true ? 0 : portal.inputs.dc_lock_value,

      mod_width: portal.inputs.mod_width,
      mod_height: portal.inputs.mod_height,
      mod_string: portal.inputs.mod_string,
      table_count: portal.inputs.table_count,

      doTopo: portal.topoData.topo_live && (portal.topoData.topo_action == "delete" || portal.topoData.topo_action == "flag"),
      topo_id: portal.topoData.topo_id,
      // grade_limit: portal.inputs.selectedProductIndex == 0 ? 10 : 20,

      grade_limit: portal.inputs.grade_limit,
      // dcac: portal.inputs.dcac,

      ns_grade_limit: portal.inputs.ns_grade_limit,
      ew_grade_limit: portal.inputs.ew_grade_limit,
      u_grade_limit: portal.inputs.u_grade_limit,
      ns_grade_enabled: portal.inputs.ns_grade_enabled,
      ew_grade_enabled: portal.inputs.ew_grade_enabled,
      u_grade_enabled: portal.inputs.u_grade_enabled,

      do_generate_layers: portal.topoData.do_generate_layers,

      grading_enabled: portal.topoData.grading.enabled,
      grade_target: portal.topoData.grading.grade_target,
      cut_amt: portal.topoData.grading.cut_amt,
      fill_amt: portal.topoData.grading.fill_amt,

      generate_ns: portal.topoData.layers_generated.NS.avail,
      generate_ew: portal.topoData.layers_generated.EW.avail,
      generate_u: portal.topoData.layers_generated.U.avail,

      layers_generated: portal.topoData.layers_generated,
      topo_action: portal.topoData.topo_action,

      // is_bifacial: portal.inputs.is_bifacial,
      // bifaciality: portal.inputs.bifaciality,
      // bifacial_transmission_factor: portal.inputs.bifacial_transmission_factor,
      // bifacial_ground_clearance_height: portal.inputs.bifacial_ground_clearance_height,
      // bifacial_structure_shade_factor: portal.inputs.bifacial_structure_shade_factor,

      // losses: {
      //   soiling_loss: portal.inputs.losses.soiling_loss,
      //   mismatch_loss: portal.inputs.losses.mismatch_loss,
      //   wiring_loss: portal.inputs.losses.wiring_loss,
      //   module_lid_loss: portal.inputs.losses.module_lid_loss,
      //   module_quality_loss: portal.inputs.losses.module_quality_loss,
      //   inverter_eff: portal.inputs.losses.inverter_eff,
      //   combined_ac_loss: portal.inputs.losses.combined_ac_loss,
      // },

			performance: { ...portal.inputs.performance },
			layout: { ...portal.inputs.layout }
    };
  };

  const handleSubmit = async () => {
    // if (submissionValidate() !== true) {
    //   return;
    // }
    // get rbi inputs
    // let rbi_inputs = collectInputs();
    // convert to swm inputs
    // let swm_inputs = convert_to_swm(rbi_inputs);
    // console.log(swm_inputs)
    // return
    // let inputs = getGroundMountInputs(portal);
		let soiling = inputs.soiling;
		let albedo = inputs.albedo;
		if (inputs.do_monthly_losses == 0) {
			// single values in input, spead to monthly
			soiling = Array(12).fill(inputs.soiling_single)
			albedo = Array(12).fill(inputs.albedo_single)
		}
		let job_inputs = { 
			...inputs,
			site_features: Object.values(inputs.site_features),
			gcrs: getGCRs(inputs.gcr_min, inputs.gcr_max, inputs.gcr_inc),
			tilts: inputs.track_mode == 0 ? getTilts(inputs.tilt_min, inputs.tilt_max, inputs.tilt_inc) : [0],
			soiling,
			albedo
		}
    // init run in the backend
    // dispatch(portalActions.initResults(inputs));
		dispatch(execute_job(run_job(job_inputs)))
  };


  const moduleHeader = (
    <div style={{ display: "flex", alignItems: "center" }}>
      <img src={product} style={{ height: "25px", width: "25px", marginRight: "5px" }} />
      <p style={{ margin: "0" }}>Module</p>
    </div>
  );

  const perfHeader = (
    <div style={{ display: "flex", alignItems: "center" }}>
      <img src={performance} style={{ height: "25px", width: "25px", marginRight: "5px" }} />
      <p style={{ margin: "0" }}>Performance</p>
    </div>
  );

  const layoutHeader = (
    <div style={{ display: "flex", alignItems: "center" }}>
      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M22.41 3.45225C21.9064 3.42437 21.4359 3.77628 21.4359 4.30674V7.58541H13.3698L13.0123 6.83804C13.8398 5.74083 13.4839 4.12022 12.2814 3.46158L12.3069 1.05074C12.3215 -0.341254 10.1772 -0.351605 10.1626 1.02813L10.1372 3.43643C8.92227 4.0691 8.53203 5.68594 9.3353 6.79908L8.93853 7.58541H0.854492C0.38335 7.58541 0 7.96876 0 8.4399V24.1128C0 24.5839 0.38335 24.9672 0.854492 24.9672H22.5622C23.8991 24.9672 24.9877 23.8853 24.9995 22.5511C24.9996 22.5474 25 22.5439 25 22.5401V6.04234C25 4.61417 23.8381 3.45225 22.41 3.45225V3.45225ZM22.1684 4.30674C22.1684 4.18555 22.321 4.16544 22.41 4.18467C23.4343 4.18467 24.2676 5.01798 24.2676 6.04229V20.7995C23.8274 20.368 23.225 20.1016 22.5615 20.1016C22.4662 20.1162 22.1684 20.1432 22.1684 19.9795V4.30674ZM16.2955 15.3983L15.9129 16.4827L11.7063 7.68956C11.9764 7.62657 12.2287 7.51602 12.453 7.36622L16.2955 15.3983ZM9.8832 7.33902C10.1042 7.49346 10.354 7.60958 10.6227 7.67823L6.23154 16.3804L5.87197 15.2882L9.8832 7.33902ZM12.4367 10.9135L9.82456 10.8859L11.1587 8.24195L12.4367 10.9135ZM10.895 1.03589C10.8997 0.588287 11.579 0.607477 11.5744 1.04302L11.5516 3.21119C11.3273 3.17515 11.0972 3.17222 10.8721 3.20289L10.895 1.03589ZM10.1026 4.35733C10.3938 4.07227 10.7972 3.91109 11.2043 3.91456C12.0597 3.92359 12.7482 4.62681 12.7393 5.48218C12.7303 6.33204 12.0361 7.01719 11.1882 7.01719C11.1827 7.01719 11.1771 7.01714 11.1716 7.0171C10.3162 7.00806 9.62773 6.30484 9.63672 5.44947C9.64106 5.03511 9.80654 4.64722 10.1026 4.35733V4.35733ZM22.5622 24.2349H0.854492C0.787158 24.2349 0.732422 24.1801 0.732422 24.1128V8.43995C0.732422 8.37266 0.787158 8.31788 0.854492 8.31788H8.56885L7.28652 10.8591L6.04941 10.8461C5.57881 10.8377 5.56899 11.5734 6.0417 11.5784L6.9189 11.5877L5.19521 15.0036C5.12183 15.1491 5.10947 15.3144 5.1604 15.4692L5.62817 16.89C5.79468 17.3958 6.51255 17.4494 6.75239 16.9741L9.45684 11.6145L12.7889 11.6497L15.3793 17.0646C15.608 17.5426 16.3285 17.5058 16.5055 17.0043L17.0029 15.5943C17.0572 15.4406 17.0483 15.2749 16.9779 15.1278L15.3268 11.6764L16.204 11.6857C16.6746 11.694 16.6844 10.9583 16.2117 10.9533L14.9746 10.9402L13.7201 8.31783H21.4358V19.9796C21.4358 20.6222 22.0158 20.8543 22.5614 20.8341C23.5003 20.8341 24.2644 21.5965 24.2674 22.5348C24.2645 23.4727 23.5007 24.2349 22.5622 24.2349Z"
          fill="#333333"
        />
        <path
          d="M19.1807 18.2251H2.98718C2.65061 18.2251 2.37683 18.4989 2.37683 18.8354V22.1558C2.37683 22.4923 2.65061 22.7661 2.98718 22.7661H19.1808C19.5174 22.7661 19.7911 22.4923 19.7911 22.1558V18.8354C19.7911 18.4989 19.5173 18.2251 19.1807 18.2251ZM19.0587 22.0337H3.10925V18.9575H4.05295V19.6131C4.05295 20.0714 4.78538 20.0923 4.78538 19.6131V18.9575H5.71916V20.1014C5.71916 20.5597 6.45159 20.5806 6.45159 20.1014V18.9575H7.38533V19.6131C7.38533 20.0714 8.11775 20.0923 8.11775 19.6131V18.9575H9.05154V20.1014C9.05154 20.5597 9.78396 20.5806 9.78396 20.1014V18.9575H10.7177V19.6131C10.7177 20.0714 11.4502 20.0923 11.4502 19.6131V18.9575H12.384V20.1014C12.384 20.5597 13.1164 20.5806 13.1164 20.1014V18.9575H14.0502V19.6131C14.0502 20.0714 14.7826 20.0923 14.7826 19.6131V18.9575H15.7163V20.1014C15.7163 20.5597 16.4488 20.5806 16.4488 20.1014V18.9575H17.3825V19.6131C17.3825 20.0714 18.115 20.0923 18.115 19.6131V18.9575H19.0587V22.0337Z"
          fill="#333333"
        />
      </svg>

      <p style={{ margin: "0", marginLeft: "6px" }}>Layout</p>
    </div>
  );

  const topoHeader = (
    <div style={{ display: "flex", alignItems: "center" }}>
      <img src={mountains} style={{ height: "25px", width: "25px", marginRight: "5px" }} />

      <p style={{ margin: "0" }}>Topography</p>
    </div>
  );

  const rackingHeader = (
    <div style={{ display: "flex", alignItems: "center" }}>
      <img src={racking_icon} style={{ height: "25px", width: "25px", marginRight: "5px" }} />

      <p style={{ margin: "0" }}>Racking</p>
    </div>
  );

  return (
    <GroundControlPanelWrapper panelScrollPosition={panelScrollPosition}>
      <ProjectManager mode="ground" collectInputs={collectInputs} />

      {/* tabs */}
      <section className="portal-tabs">
        <section className={`tab ${inputs.uiState.tab == "simplified" ? "active" : ""}`} onClick={() => dispatch(inputsActions.update_ui_state("tab", "simplified"))}>
          Simplified
        </section>
        <section className={`tab ${inputs.uiState.tab == "advanced" ? "active" : ""}`} onClick={() => dispatch(inputsActions.update_ui_state("tab", "advanced"))}>
          Advanced
        </section>
      </section>

      {/* inputs */}
      {inputs.uiState.tab == "simplified" ? (
        <SimpleInputs />
      ) : (
        <Fragment>
          <section className="gm-input-panels" ref={toolPanelInput} onScroll={getScrollPosition}>
            <section className="simple-select-dropdown top-border">
              <label>Product</label>
              <Select
                showSearch
                optionFilterProp="children"
                onChange={(value) => {
									dispatch(inputsActions.select_product(parseInt(value)))
                }}
                value={portal.products[inputs.uiState.selected_product_index]?.racking_name || "Select a Product"}
                filterOption={(input, option) => option.children.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
                {Object.values(portal.products).map((product, index) => (
                  <Select.Option key={index} value={index}>
                    <span>{product.racking_name}</span>
                  </Select.Option>
                ))}
              </Select>
            </section>
            <Collapse expandIconPosition="right" defaultActiveKey={[]}>
              <Collapse.Panel className="custom-input-panel-header" header={moduleHeader} key="module">
                <InputHeader mode="portal" tab="module" />
                <ModuleInputs mode="portal" />
              </Collapse.Panel>
              <Collapse.Panel className="custom-input-panel-header" header={rackingHeader} key="racking">
                {/* <InputHeader mode="portal" tab="racking" /> */}
                <RackingInputs panelScrollPosition={panelScrollPosition} panelOffsetTop={panelOffsetTop} />
              </Collapse.Panel>
              <Collapse.Panel className="custom-input-panel-header" header={perfHeader} key="performance">
                <PerformanceInputs />
              </Collapse.Panel>
              <Collapse.Panel className="custom-input-panel-header" header={layoutHeader} key="layout">
                <LayoutInputs />					
              </Collapse.Panel>							
              <Collapse.Panel className="custom-input-panel-header" header={topoHeader} key="topography">
                <TopographyInputs />
              </Collapse.Panel>
            </Collapse>
          </section>
        </Fragment>
      )}

      {/* Generate Buttons */}
      <div className="generate-buttons-container">
        {portal.inputs.inputsHaveChanged && !portal.isRunning && (
          <div className="inputs-have-changed">
            <Typography.Text type="danger">*Inputs have changed since last results were generated</Typography.Text>
          </div>
        )}
        <div className="generate-buttons">
          <Button type="primary" loading={portal.isRunning} onClick={() => handleSubmit()} disabled={Object.values(inputs.site_features).length <= 0 ? true : false}>
            Generate
          </Button>
          {!portal.hasResults && (
            <Button onClick={() => dispatch(portalActions.cancelRun(portal.inputs.run_id))} type="danger" disabled={!portal.inputs.run_id} loading={portal.uiControls.canceling}>
              Cancel
            </Button>
          )}
          {portal.hasResults && (
            <Button type="primary" ghost onClick={() => dispatch(portalActions.updateUIControls("show_results_table", !portal.uiControls.show_results_table))}>
              <span>{portal.uiControls.show_results_table ? "Hide" : "View"} Results</span>
            </Button>
          )}
        </div>
      </div>
    </GroundControlPanelWrapper>
  );
};

export { GroundMountControlPanel };
